import { Code, Database, Cog, Zap, Palette, Building2, Leaf, TreePine, Wrench, ArrowUpRight } from "lucide-react"
import { useServiceSelection } from "@/components/ServiceSelectionProvider"
import { useLanguage } from "@/contexts/LanguageContext"

const ServicesSection = () => {
  const { addService } = useServiceSelection()
  const { t } = useLanguage()

  const scrollToContact = () => {
    const el = document.getElementById('contact')
    if (!el) return
    window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - 80, behavior: 'smooth' })
  }
  const handle = (name: string) => { addService(name.toLowerCase().replace(/\s+/g, '-'), name); scrollToContact() }

  const services = [
    { icon: Code, n: "01", title: t('services.computer'), desc: t('services.computer.desc') },
    { icon: Zap, n: "02", title: t('services.microtechnics'), desc: t('services.microtechnics.desc') },
    { icon: Cog, n: "03", title: t('services.mechanical'), desc: t('services.mechanical.desc') },
    { icon: Palette, n: "04", title: t('services.architecture'), desc: t('services.architecture.desc') },
    { icon: Building2, n: "05", title: t('services.civil'), desc: t('services.civil.desc') },
    { icon: Database, n: "06", title: t('services.agronomy'), desc: t('services.agronomy.desc') },
    { icon: Leaf, n: "07", title: t('services.nature'), desc: t('services.nature.desc') },
    { icon: TreePine, n: "08", title: t('services.landscape'), desc: t('services.landscape.desc') },
    { icon: Wrench, n: "09", title: t('services.building'), desc: t('services.building.desc') },
  ]

  return (
    <section id="services" className="py-24 md:py-32 bg-je-ivory">
      <div className="container-editorial">
        <div className="grid grid-cols-12 gap-8 mb-16 md:mb-20">
          <div className="col-span-12 md:col-span-5">
            <span className="eyebrow mb-5">02 — Expertises</span>
            <h2 className="text-section-title font-serif font-medium text-je-black mt-4 text-balance">{t('services.title')}</h2>
          </div>
          <div className="col-span-12 md:col-span-6 md:col-start-7 flex items-end">
            <p className="text-lg text-je-gray-dark text-pretty">{t('services.subtitle')}</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-l border-je-navy/15">
          {services.map((s) => (
            <button key={s.n} onClick={() => handle(s.title)}
              className="text-left p-8 lg:p-10 border-r border-b border-je-navy/15 bg-je-white hover:bg-je-navy hover:text-je-white transition-all duration-500 group relative">
              <div className="flex items-start justify-between mb-10">
                <span className="font-mono text-xs tracking-widest text-je-gray-dark group-hover:text-je-white/60 transition-colors">{s.n}</span>
                <s.icon className="w-5 h-5 text-je-red" strokeWidth={1.5} />
              </div>
              <h3 className="font-serif text-2xl font-medium text-je-black group-hover:text-je-white mb-3 leading-tight transition-colors">{s.title}</h3>
              <p className="text-sm text-je-gray-dark group-hover:text-je-white/70 leading-relaxed transition-colors">{s.desc}</p>
              <div className="mt-8 flex items-center gap-2 text-xs font-medium text-je-red opacity-0 group-hover:opacity-100 transition-opacity">
                {t('services.request')} <ArrowUpRight className="w-3.5 h-3.5" />
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  )
}
export default ServicesSection
